import React from 'react';
import { SKILL_ICONS } from './SkillIcons';

function Tile({ item }) {
  const Icon = SKILL_ICONS[item.name];

  return (
    <div
      className="flex flex-col items-center gap-3 rounded-xl p-[18px_14px] transition-all duration-200 cursor-default"
      style={{
        width: 120,
        flexShrink: 0,
        background: 'rgba(255,255,255,0.06)',
        border: '1px solid rgba(255,255,255,0.10)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(255,255,255,0.10)';
        e.currentTarget.style.borderColor = 'rgba(255,255,255,0.20)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(255,255,255,0.06)';
        e.currentTarget.style.borderColor = 'rgba(255,255,255,0.10)';
        e.currentTarget.style.transform = '';
      }}
    >
      <div
        className="flex items-center justify-center rounded-button"
        style={{ width: 44, height: 44, background: 'rgba(255,255,255,0.08)' }}
      >
        {Icon ? (
          <Icon size={22} color="rgba(255,255,255,0.90)" />
        ) : (
          <span className="font-mono font-medium text-accent text-[13px] tracking-[0.02em]">
            {item.mono}
          </span>
        )}
      </div>
      <div className="text-[13px] text-center leading-[1.25]" style={{ color: 'rgba(255,255,255,0.92)' }}>
        {item.name}
      </div>
    </div>
  );
}

export default function Skills({ t }) {
  return (
    <section id="skills" className="bg-band text-bg">
      <div className="max-w-content mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="mb-10 md:mb-14">
          <div
            className="font-mono text-[13px] tracking-eyebrow uppercase"
            style={{ color: 'rgba(255,255,255,0.55)' }}
          >
            02 / {t.nav.skills}
          </div>
        </div>

        <div className="mb-12 md:mb-16">
          <h3
            className="font-display font-medium text-bg m-0 mb-7"
            style={{ fontSize: 'clamp(32px, 4vw, 48px)', letterSpacing: '-0.02em', lineHeight: 1.05 }}
          >
            {t.skills.main.label}
          </h3>
          <div className="flex flex-wrap justify-center gap-3">
            {t.skills.main.items.map((item, i) => <Tile key={i} item={item} />)}
          </div>
        </div>

        <div>
          <h3
            className="font-display font-medium text-bg m-0 mb-7"
            style={{ fontSize: 'clamp(32px, 4vw, 48px)', letterSpacing: '-0.02em', lineHeight: 1.05 }}
          >
            {t.skills.complementary.label}
          </h3>
          <div className="flex flex-wrap justify-center gap-3">
            {t.skills.complementary.items.map((item, i) => <Tile key={i} item={item} />)}
          </div>
        </div>
      </div>
    </section>
  );
}
